import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Lifecycle } from '../../_helpers/Lifecycle/Lifecycle.class';
import { $DBManagerService } from '../../_helpers/DB/DBManager.service';
import { Constants } from '../../_utils/Constants';
import { $BroadcastManagerService } from '../../_helpers/BroadcastManager.service';


@Component({
  selector: 'r-tabs-header',
  templateUrl: './tabs-header.component.html',
  styleUrls: ['./tabs-header.component.css']
})
export class TabsHeaderComponent extends Lifecycle {

  //nav bar testing
  navbarOpen = false;

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  public userRole: String | null;
  public user: any;
  public params: any;
  homeRole: boolean;
  TataEmpRoles:any;
  loginFlag: boolean = false;
  constructor(
    public router: Router,
    private db: $DBManagerService,
    private evt: $BroadcastManagerService,
    private _route: ActivatedRoute
  ) {
    super();
  }
 
  _initialize(): void {
    this.userRole = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_ROLE);
   // console.log("this.userRole  in tabs header:",this.userRole); 
    this.user = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_NAME);
    this.homeRole = this.db.get(Constants.SESSSION_STORAGE, Constants.HOME_ROLE);
  this.loginFlag = this.db.get(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG);

    this.evt.getInstance()
      .subscribe(r => {
        if (r.click === 'HEADER_EVENT')
          this.userRole = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_ROLE);
          this.user = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_NAME);
          this.homeRole = this.db.get(Constants.SESSSION_STORAGE, Constants.HOME_ROLE);

          this.loginFlag = this.db.get(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG);
		 // console.log("HEADER_EVENT this.userRole, this.user, this.homeRole, this.loginFlag", this.userRole, this.user, this.homeRole, this.loginFlag) 
		  
      });
  }
 
  _destroy(): void {
      
  }

}
